import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from 'app';
import { AuthContextProvider, KeycloakProvider } from 'shared/services/auth';
import { store } from 'shared/services/redux/store';

const root = createRoot(document.getElementById('root')!);

root.render(
  <KeycloakProvider>
    <Provider store={store}>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </Provider>
  </KeycloakProvider>,
);
